function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6,
  y: 5,
  width: 16,
  height: 2,
  rx: 1
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 2,
  y: 5,
  width: 2,
  height: 2,
  rx: 1
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6,
  y: 11,
  width: 16,
  height: 2,
  rx: 1
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 2,
  y: 11,
  width: 2,
  height: 2,
  rx: 1
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6,
  y: 17,
  width: 16,
  height: 2,
  rx: 1
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 2,
  y: 17,
  width: 2,
  height: 2,
  rx: 1
});

var SvgList = function SvgList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list.ac34b4ed.svg";
export { ForwardRef as ReactComponent };